import React, { useEffect, useState } from "react"
import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"
import { Row, Col } from "reactstrap"

function HitsByImgTypeChart({data}) {
  const [chartData, setChartData] = useState([])

  // Define the color palette
  const colorPalette = ["#01B8AA", "#6F4EF2", "#2C8CFF", "#00D1B2", "#A9B0C0"]
console.log("apiData", data)
  // Simulate API call or use your own fetch logic
  useEffect(() => {
    // const apiData = [
    //   { name: "Landmarks", y: 2010 },
    //   { name: "Animals", y: 1320 },
    //   { name: "Cards", y: 987 },
    //   { name: "Objects", y: 654 },
    //   { name: "Symbols", y: 400 },
    // ]

    // Add color manually from palette
    const coloredData = data.map((item, idx) => ({
      ...item,
      color: colorPalette[idx % colorPalette.length],
    }))

    setChartData(coloredData)
  }, [data])

  const total = data.reduce((acc, item) => acc + item.y, 0)

  const options = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
    },
    title: {
      text: "Hits by Image Type",
    },
    tooltip: {
      pointFormat: "<b>{point.y}</b> ({point.percentage:.1f}%)",
    },
    plotOptions: {
      pie: {
        innerSize: "65%",
        dataLabels: {
          enabled: false,
        },
        showInLegend: false,
      },
    },
    series: [
      {
        name: "Hits",
        data: data,
      },
    ],
    credits: {
      enabled: false,
    },
  }

  return (
    <div className="p-4 bg-white rounded shadow-sm">
      <Row>
        <Col lg={8}>
          <div style={{ maxWidth: "300px" }}>
            <HighchartsReact highcharts={Highcharts} options={options} />
          </div>
        </Col>
        <Col lg={4} className="d-flex align-items-center">
          <div className="w-100">
            {chartData.map((item, idx) => (
              <div
                key={idx}
                className="d-flex justify-content-between align-items-center border-bottom py-2"
              >
                <span style={{ color: item.color, fontWeight: 600 }}>
                  {item.name}
                </span>
                <span>
                  <strong>{item.y}</strong>{" "}
                  <span className="text-muted">
                    ({((item.y / total) * 100).toFixed(1)}%)
                  </span>
                </span>
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default HitsByImgTypeChart
